export default "__VITE_ASSET__vVT9B3Zf__"